/* RESPONSIBLE TEAM: team-ai-agent */
import OutboundBaseListController from 'embercom/lib/outbound/base-list-controller';

export default class AppsAppOperatorResolutionBotIndexController extends OutboundBaseListController {}
